export const ETL_SLICE = 'ETL_SLICE';
